export { SearchResult } from './index.pc'
export { MobileSearchResult } from './index.mobile'
